export default __webpack_public_path__ + "static/media/empty_marketplaces.ae2efec8.png";